/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum SearchCriteriaInputTypeEnum {
    INPUT_TEXT_NUMBER = 'INPUT_TEXT_NUMBER',
    INPUT_TEXT_STRING = 'INPUT_TEXT_STRING',
    INPUT_DATE = 'INPUT_DATE',
    INPUT_CURRENCY = 'INPUT_CURRENCY',
    INPUT_MULTI_SELECTION = 'INPUT_MULTI_SELECTION',
    INPUT_AUTOCOMPLETE_MULTI_SELECTION = 'INPUT_AUTOCOMPLETE_MULTI_SELECTION'
}
